import React from 'react'

export default ({ ...props }) => (
  <svg
    version='1.0'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
    width='125'
    height='100'
    viewBox='0 0 1000.000000 424.000000'
    preserveAspectRatio='xMidYMid meet'
  >
    <g transform='translate(0.000000,424.000000) scale(0.100000,-0.100000)' fill='#000000' stroke='none'>
      <path
        d='M0 3835 l0 -405 65 0 65 0 2 272 3 272 85 -272 85 -272 57 0 56 0 45
143 c25 78 63 198 85 267 l40 125 1 -267 1 -268 70 0 70 0 0 405 0 405 -93 0
-93 0 -90 -259 c-49 -143 -91 -258 -93 -256 -2 2 -43 118 -91 257 l-88 253
-91 3 -91 3 0 -406z'
      />
      <path
        d='M2123 4214 l-43 -26 0 -84 0 -84 -40 0 -40 0 0 -70 0 -70 40 0 40 0
0 -152 c0 -127 4 -160 19 -193 34 -75 91 -104 209 -105 l72 0 0 70 0 69 -56 3
c-49 3 -60 7 -78 31 -18 25 -21 45 -24 153 l-4 124 76 0 76 0 0 70 0 70 -75 0
-75 0 0 110 0 110 -27 0 c-16 -1 -47 -12 -70 -26z'
      />
      <path d='M2730 4160 l0 -80 75 0 75 0 0 80 0 80 -75 0 -75 0 0 -80z' />
      <path
        d='M987 4016 c-67 -25 -111 -71 -132 -140 -20 -65 -20 -236 0 -302 29
-98 117 -156 239 -157 146 -1 230 55 251 166 l7 37 -76 0 c-67 0 -76 -2 -76
-18 0 -42 -81 -74 -145 -58 -32 8 -65 60 -65 104 l0 32 180 0 180 0 0 88 c0
77 -4 96 -27 143 -42 81 -98 112 -211 116 -58 2 -100 -1 -125 -11z m184 -135
c19 -20 29 -40 29 -60 l0 -31 -105 0 c-102 0 -105 1 -105 23 2 86 118 130 181
68z'
      />
      <path
        d='M1587 4016 c-67 -25 -111 -71 -132 -140 -20 -65 -20 -236 0 -302 29
-98 117 -156 239 -157 146 -1 230 55 251 166 l7 37 -74 0 c-73 0 -74 0 -85
-30 -13 -34 -46 -50 -103 -50 -54 0 -88 32 -99 93 l-8 47 184 0 185 0 -4 98
c-5 121 -28 171 -101 216 -43 26 -60 30 -135 33 -58 2 -100 -1 -125 -11z m184
-135 c19 -20 29 -40 29 -60 l0 -31 -105 0 c-102 0 -105 1 -105 23 2 86 118
130 181 68z'
      />
      <path
        d='M3184 4005 c-49 -25 -49 -25 -63 -5 -10 15 -25 20 -62 20 l-49 0 0
-295 0 -295 75 0 75 0 0 199 c0 184 1 200 20 224 47 59 143 56 181 -7 17 -28
19 -51 19 -223 l0 -193 76 0 76 0 -4 218 -3 218 -30 59 c-40 78 -88 105 -190
105 -57 0 -82 -5 -121 -25z'
      />
      <path d='M2730 3725 l0 -295 75 0 75 0 0 295 0 295 -75 0 -75 0 0 -295z' />
      <path
        d='M4055 3251 l-100 -57 -3 -842 -2 -842 145 0 145 0 2 286 3 285 230
-285 229 -286 173 0 c95 0 173 2 173 5 0 3 -112 147 -250 320 -137 173 -250
317 -250 320 0 3 113 129 250 280 138 152 250 277 250 280 0 3 -80 5 -178 5
l-178 0 -224 -245 -225 -245 -3 540 -2 540 -43 -1 c-32 0 -65 -13 -142 -58z'
      />
      <path
        d='M9013 3253 l-103 -58 0 -842 0 -843 145 0 145 0 2 282 3 281 225
-281 225 -281 173 0 c94 -1 172 2 172 7 0 4 -112 148 -250 321 l-249 315 31
35 c17 20 128 143 247 274 119 131 218 242 219 247 2 6 -65 10 -175 9 l-178 0
-220 -241 -220 -241 -3 537 -2 536 -43 0 c-33 0 -65 -13 -144 -57z'
      />
      <path
        d='M0 2350 l0 -840 150 0 150 0 0 320 0 320 179 0 178 0 134 -320 134
-320 158 0 c86 0 157 1 157 3 0 2 -63 158 -140 347 -77 189 -139 344 -138 345
2 1 23 13 48 27 62 36 137 118 165 182 65 147 60 406 -11 536 -37 69 -121 145
-199 181 -109 51 -179 58 -592 59 l-373 0 0 -840z m829 530 c72 -40 86 -74 86
-210 0 -102 -2 -119 -23 -152 -14 -22 -41 -46 -70 -60 -44 -22 -60 -23 -284
-26 l-238 -3 0 241 0 241 243 -3 c237 -3 243 -4 286 -28z'
      />
      <path
        d='M8421 3158 c-5 -13 -36 -92 -70 -176 -34 -84 -61 -154 -61 -157 0 -3
62 -5 138 -5 l138 0 95 171 c52 94 96 175 97 180 2 5 -70 9 -162 9 -163 0
-167 0 -175 -22z'
      />
      <path d='M5250 3015 l0 -155 145 0 145 0 0 155 0 155 -145 0 -145 0 0 -155z' />
      <path
        d='M1740 2734 c-182 -39 -309 -158 -357 -335 -23 -83 -26 -463 -4 -549
45 -184 167 -308 347 -354 81 -21 269 -21 349 -1 133 34 230 104 282 202 27
49 53 144 53 190 0 10 -32 13 -144 13 l-144 0 -11 -46 c-15 -58 -55 -97 -123
-120 -90 -30 -218 -5 -270 53 -29 31 -55 104 -62 171 l-7 62 381 0 380 0 0
163 c0 232 -28 322 -132 426 -118 118 -337 169 -538 125z m256 -245 c39 -12
88 -64 103 -108 6 -19 11 -56 11 -82 l0 -49 -228 0 -229 0 9 58 c25 161 162
235 334 181z'
      />
      <path
        d='M6125 2738 c-124 -23 -232 -105 -281 -213 -47 -103 -56 -177 -52
-450 4 -228 6 -256 27 -315 43 -126 126 -214 241 -256 58 -22 265 -31 341 -15
54 11 153 55 196 87 21 15 22 14 43 -25 l20 -41 100 0 100 0 0 605 0 605 -98
0 -98 0 -22 -45 -22 -46 -33 24 c-110 83 -294 117 -462 85z m283 -273 c66 -20
109 -57 138 -120 22 -46 24 -62 24 -226 0 -198 -10 -244 -62 -298 -47 -48 -85
-64 -164 -69 -115 -7 -193 29 -237 111 -21 40 -22 54 -22 247 0 195 1 207 23
252 49 98 172 141 300 103z'
      />
      <path
        d='M2640 2363 c0 -197 5 -399 10 -449 24 -231 114 -363 283 -415 58 -18
87 -21 187 -17 112 4 122 6 191 40 l72 36 -5 -102 c-9 -164 -56 -226 -190
-248 -114 -20 -229 33 -244 111 l-6 31 -149 0 -148 0 5 -32 c34 -206 129 -313
327 -365 77 -20 260 -23 337 -4 195 47 324 182 350 366 5 40 10 351 10 738 l0
667 -144 0 -145 0 -3 -397 c-3 -357 -5 -402 -21 -438 -39 -86 -113 -134 -207
-135 -99 0 -174 55 -200 149 -6 21 -10 196 -10 429 l0 392 -150 0 -150 0 0
-357z'
      />
      <path
        d='M5248 2043 c-3 -662 -3 -679 -24 -718 -28 -55 -88 -85 -171 -85 l-63
0 0 -136 0 -136 133 4 c154 5 217 24 291 89 52 46 101 138 116 218 6 33 10
325 10 747 l0 694 -145 0 -144 0 -3 -677z'
      />
      <path
        d='M7024 2703 c43 -138 356 -1184 356 -1188 0 -3 87 -5 193 -5 l192 0
178 593 c98 325 178 598 177 605 0 9 -36 12 -147 12 l-148 0 -120 -439 c-66
-242 -122 -438 -124 -435 -3 3 -62 199 -132 437 l-126 432 -152 3 c-142 2
-152 1 -147 -15z'
      />
      <path d='M8290 2115 l0 -605 145 0 145 0 0 605 0 605 -145 0 -145 0 0 -605z' />
      <path
        d='M1133 673 l-43 -24 0 -320 0 -319 60 0 60 0 0 345 c0 389 5 367 -77
318z'
      />
      <path
        d='M2573 674 l-43 -25 0 -96 c0 -87 -1 -94 -17 -87 -10 5 -55 9 -100 9
-92 0 -122 -14 -158 -76 -17 -29 -20 -52 -20 -159 0 -141 12 -175 75 -217 42
-29 153 -32 208 -6 26 12 37 14 40 5 2 -7 22 -12 48 -12 l44 0 0 345 c0 389 5
369 -77 319z m-68 -329 c22 -22 25 -32 25 -104 0 -69 -3 -84 -23 -107 -19 -21
-32 -27 -67 -27 -35 0 -48 6 -68 28 -22 26 -24 35 -20 111 4 102 19 124 85
124 33 0 50 -6 68 -25z'
      />
      <path
        d='M3056 645 c-48 -17 -83 -42 -110 -79 -19 -25 -21 -44 -24 -223 -4
-219 -1 -234 58 -287 47 -43 93 -56 190 -56 95 0 141 13 187 53 46 40 63 82
63 152 l0 55 -59 0 -58 0 -6 -46 c-7 -68 -40 -96 -115 -102 -64 -5 -113 13
-132 47 -14 26 -13 316 1 343 25 47 139 63 197 28 35 -22 52 -54 52 -101 0
-29 0 -29 60 -29 l60 0 0 58 c0 95 -55 166 -149 192 -51 14 -169 12 -215 -5z'
      />
      <path
        d='M5808 627 c-38 -22 -38 -22 -38 -89 l0 -68 -30 0 c-30 0 -30 -1 -30
-55 0 -54 1 -55 29 -55 l29 0 3 -128 c4 -142 13 -167 72 -202 23 -15 50 -20
100 -20 l67 0 0 55 0 55 -44 0 c-65 0 -76 20 -76 142 l0 98 55 0 55 0 0 55 0
55 -55 0 -55 0 0 90 c0 87 -1 90 -22 90 -13 -1 -40 -11 -60 -23z'
      />
      <path
        d='M7390 330 l0 -320 167 0 c148 0 171 2 209 21 95 45 124 187 59 283
l-24 36 20 35 c17 29 21 48 17 100 -5 77 -25 110 -88 143 -40 20 -58 22 -202
22 l-158 0 0 -320z m308 194 c29 -20 31 -85 2 -114 -17 -17 -33 -20 -105 -20
l-85 0 0 75 0 75 83 0 c59 0 89 -5 105 -16z m22 -264 c13 -13 20 -33 20 -60 0
-67 -22 -80 -135 -80 l-95 0 0 80 0 80 95 0 c82 0 98 -3 115 -20z'
      />
      <path
        d='M32 598 l-32 -20 0 -284 0 -284 60 0 60 0 0 305 0 305 -27 -1 c-16 0
-43 -10 -61 -21z'
      />
      <path
        d='M274 461 c-25 -12 -50 -33 -65 -57 -22 -36 -24 -49 -24 -164 0 -114
2 -128 24 -163 34 -55 84 -77 173 -77 57 0 82 5 113 23 46 25 85 92 85 144 l0
33 -60 0 c-56 0 -60 -2 -60 -23 0 -57 -63 -91 -118 -63 -38 20 -42 31 -42 132
0 101 15 124 80 124 47 0 80 -27 80 -65 0 -24 3 -25 60 -25 l60 0 0 33 c0 54
-40 118 -90 144 -56 30 -156 31 -216 4z'
      />
      <path
        d='M715 457 c-22 -13 -49 -40 -62 -62 -20 -35 -23 -54 -23 -155 0 -101
3 -120 23 -155 12 -22 40 -50 62 -63 35 -20 51 -22 127 -20 69 2 92 7 114 24
39 28 63 63 70 102 l7 32 -59 0 c-52 0 -61 -3 -69 -22 -27 -61 -124 -56 -151
8 -8 18 -14 38 -14 44 0 6 52 10 145 10 l145 0 0 73 c0 141 -65 207 -204 207
-55 0 -80 -5 -111 -23z'
      />
      <path
        d='M1350 457 c-63 -42 -75 -76 -75 -217 0 -141 12 -175 75 -217 42 -29
153 -32 208 -6 26 12 37 14 40 5 2 -7 22 -12 48 -12 l44 0 0 230 0 230 -44 0
c-27 0 -46 -5 -49 -12 -3 -10 -13 -9 -41 5 -56 26 -163 23 -206 -6z m195 -112
c22 -22 25 -32 25 -104 0 -69 -3 -84 -23 -107 -33 -38 -101 -38 -134 0 -20 23
-23 38 -23 105 0 102 19 131 86 131 34 0 51 -6 69 -25z'
      />
      <path
        d='M1897 461 c-32 -16 -39 -17 -44 -5 -3 9 -20 14 -44 14 l-39 0 0 -230
0 -230 55 0 55 0 0 145 c0 187 12 215 91 215 74 0 89 -37 89 -227 l0 -133 55
0 55 0 0 173 c0 159 -2 176 -22 217 -14 27 -36 50 -58 62 -47 25 -144 24 -193
-1z'
      />
      <path
        d='M3568 460 c-49 -26 -74 -61 -87 -121 -24 -111 -7 -230 41 -285 38
-43 86 -57 181 -52 80 4 111 18 150 69 28 39 43 154 29 241 -13 84 -32 115
-92 146 -58 29 -168 30 -222 2z m178 -111 c16 -17 19 -37 19 -110 0 -78 -3
-91 -23 -111 -34 -34 -97 -31 -129 6 -23 27 -25 36 -21 112 4 103 19 124 88
124 35 0 52 -5 66 -21z'
      />
      <path
        d='M4078 460 c-31 -17 -37 -17 -42 -5 -3 10 -19 15 -46 15 l-40 0 0
-230 0 -230 60 0 60 0 0 155 c0 152 1 156 25 180 35 36 96 35 124 -1 19 -24
21 -40 21 -180 l0 -154 61 0 61 0 -4 178 c-3 198 -11 225 -78 269 -44 30 -147
31 -202 3z'
      />
      <path
        d='M4900 458 c-73 -37 -90 -78 -90 -218 0 -101 3 -120 23 -155 12 -22
40 -50 62 -63 35 -20 51 -22 127 -20 69 2 92 7 114 24 38 28 61 62 69 102 l7
32 -59 0 c-51 0 -60 -3 -68 -22 -27 -61 -124 -56 -151 8 -8 18 -14 38 -14 44
0 6 52 10 145 10 l145 0 0 69 c0 38 -5 82 -11 98 -14 38 -57 83 -96 99 -51 22
-151 18 -203 -8z'
      />
      <path
        d='M5407 461 c-32 -16 -39 -17 -44 -5 -3 9 -20 14 -49 14 l-44 0 0 -230
0 -230 60 0 60 0 0 155 c0 152 1 156 25 180 35 36 96 35 124 -1 19 -24 21 -40
21 -180 l0 -154 60 0 60 0 0 161 c0 184 -8 224 -57 271 -31 30 -40 33 -106 36
-57 3 -80 -1 -110 -17z'
      />
      <path
        d='M6326 457 c-22 -12 -47 -33 -58 -47 -39 -53 -47 -235 -14 -315 8 -18
31 -45 51 -61 31 -23 50 -29 106 -32 90 -5 132 3 169 35 45 38 61 77 67 162
14 196 -50 281 -209 281 -57 0 -82 -5 -112 -23z m183 -113 c17 -22 21 -41 21
-105 0 -68 -3 -81 -24 -106 -31 -36 -95 -39 -128 -5 -20 20 -23 33 -23 111 0
111 13 131 86 131 39 0 51 -4 68 -26z'
      />
      <path
        d='M6838 460 c-31 -17 -37 -17 -42 -5 -3 10 -19 15 -46 15 l-40 0 0
-230 0 -230 60 0 60 0 0 155 c0 152 1 156 25 180 35 36 96 35 124 -1 19 -24
21 -40 21 -180 l0 -154 61 0 61 0 -4 178 c-3 198 -11 225 -78 269 -44 30 -147
31 -202 3z'
      />
      <path
        d='M8531 459 c-40 -17 -46 -18 -53 -4 -6 9 -23 15 -48 15 l-40 0 0 -230
0 -230 60 0 60 0 0 158 c0 145 2 160 20 180 24 25 60 36 95 30 24 -5 25 -3 25
48 l0 54 -37 0 c-21 0 -58 -10 -82 -21z'
      />
      <path
        d='M8775 466 c-40 -17 -82 -67 -95 -114 -13 -48 -13 -176 0 -224 14 -48
55 -97 97 -114 49 -21 171 -18 213 5 43 22 80 74 80 112 0 28 -1 29 -54 29
-47 0 -56 -3 -61 -21 -9 -26 -67 -51 -100 -43 -32 8 -65 49 -65 80 l0 24 140
0 140 0 0 84 c0 97 -19 136 -85 173 -47 26 -159 31 -210 9z'
      />
      <path
        d='M9200 457 c-63 -42 -75 -76 -75 -217 0 -141 12 -175 75 -217 42 -29
153 -32 208 -6 26 12 37 14 40 5 2 -7 22 -12 48 -12 l44 0 0 230 0 230 -44 0
c-27 0 -46 -5 -49 -12 -3 -10 -13 -9 -41 5 -56 26 -163 23 -206 -6z m191 -106
c20 -16 24 -30 27 -92 5 -91 -8 -126 -50 -144 -43 -17 -83 -9 -108 23 -16 20
-20 40 -20 102 0 100 20 130 85 130 27 0 51 -7 66 -19z'
      />
      <path
        d='M4372 453 c3 -10 34 -114 69 -230 l63 -213 77 0 76 0 67 222 c36 123
66 226 66 231 0 4 -26 7 -59 7 l-59 0 -32 -117 c-17 -65 -37 -138 -44 -161
l-12 -44 -33 114 c-19 62 -40 134 -48 161 l-14 47 -61 0 c-53 0 -60 -2 -56
-17z'
      />
      <path d='M6050 240 l0 -230 60 0 60 0 0 230 0 230 -60 0 -60 0 0 -230z' />
      <path
        d='M7922 283 c3 -178 4 -190 26 -221 13 -18 36 -39 52 -47 39 -20 142
-19 183 1 21 12 32 13 35 5 2 -6 24 -11 48 -11 l44 0 0 230 0 230 -60 0 -60 0
0 -154 c0 -148 -1 -156 -23 -182 -30 -35 -79 -37 -110 -5 -21 20 -22 32 -25
181 l-3 160 -55 0 -56 0 4 -187z'
      />
      <path
        d='M9612 293 c4 -192 9 -212 63 -263 36 -33 144 -41 201 -14 27 13 39
15 42 6 2 -7 21 -12 43 -12 l39 0 0 230 0 230 -54 0 -55 0 -3 -159 c-3 -138
-5 -162 -22 -179 -34 -39 -104 -31 -125 14 -7 15 -11 84 -11 174 l0 150 -61 0
-61 0 4 -177z'
      />
    </g>
  </svg>
)
